import React from 'react';
import clsx from 'clsx';
import { yesNoSort } from 'utils/sort/yes-no-sort';
import { Checkbox } from '../checkbox';

export interface IListTextFilter {
    filter: any;
    onFilterChange: (filterId: number, value: any) => void;
    sortListItems?: (a: string, b: string) => number;
    className?: string;
}

export const ListTextFilter: React.FC<IListTextFilter> = (props): JSX.Element => {
    const {
        filter,
        onFilterChange,
        sortListItems = yesNoSort,
        className
    } = props;

    const handleChange = (variant) => {
        let value = filter.value !== null ? [ ...filter.value ] : [];
        if (value.includes(variant)) {
            value.splice(value.indexOf(variant), 1);
        } else {
            value.push(variant);
        }
        onFilterChange(filter.id, value.length === 0 ? null : value);
    };

    let { values }: { values: string[] } = filter;

    if (sortListItems) {
        values = values.sort(sortListItems);
    }

    return (
        <div className={clsx('objects-filter', className)}>
            { !!filter.name && (
                <div className="objects-filter__name">{filter.name}</div>
            ) }

            <ul className="objects-filter-list">
                {values.map((variant, index) => {
                    let _variant = variant.replace('&#x27;', "'");
                    const key = `${filter.id}_${index}`;
                    return (
                        <li key={key} className="objects-filter-list__item">
                            <label>
                                <Checkbox
                                    checked={filter.value !== null && filter.value.includes(_variant)}
                                    onChange={() => handleChange(_variant)}
                                />
                                <span className="objects-filter-list__variant">
                                    {_variant.replace(/&quot;/g, '"')}
                                </span>
                            </label>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
